export default __webpack_public_path__ + "static/media/top-ten-block-10.768e602e.svg";